import { getQuestions } from "@/female/constants/questions";
import { Question } from "@/types/question";

// for questions shown with condition only
const mockedConditionalAnswers = {};

// it's needed only if experiment changes amount of questions or header titles
type Experiments = {
    isWeightPredictor?: boolean;
    isNumberOfStepsExp?: boolean;
};
export const getAllPossibleQuestions = (
    prefix: string,
    isAndroid: boolean,
    { isWeightPredictor = false, isNumberOfStepsExp = false }: Experiments
): Question[] => {
    return getQuestions(
        prefix,
        mockedConditionalAnswers,
        [],
        isAndroid,
        isWeightPredictor,
        isNumberOfStepsExp
    ) as unknown as Question[];
};
